
import {Component, Vue, Watch} from "vue-property-decorator";
import LogTable from "@/components/logs/LogTable.vue";

@Component({
  components: {
      LogTable,
  },
})
export default class AdminLogs extends Vue {

  private logs: any = {};
  private loadingLogs: boolean = false;

  private getLogs(params?: any) {
    this.loadingLogs = true;
    return this.$store.dispatch("logs/getLogs", {
        query: params,
    })
    .then((res) => {
        this.logs = res;
    })
    .finally(() => {
        this.loadingLogs = false;
    });
  }
}
